var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrosoftExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H30C30.5304 2 31.0391 2.21071 31.4142 2.58579C31.7893 2.96086 32 3.46957 32 4V28C32 28.5304 31.7893 29.0391 31.4142 29.4142C31.0391 29.7893 30.5304 30 30 30H10C9.46957 30 8.96086 29.7893 8.58579 29.4142C8.21071 29.0391 8 28.5304 8 28V24C8 23.6318 8.29848 23.3333 8.66667 23.3333C9.03486 23.3333 9.33333 23.6318 9.33333 24V28C9.33333 28.1768 9.40357 28.3464 9.5286 28.4714C9.65362 28.5964 9.82319 28.6667 10 28.6667H30C30.1768 28.6667 30.3464 28.5964 30.4714 28.4714C30.5964 28.3464 30.6667 28.1768 30.6667 28V4C30.6667 3.82319 30.5964 3.65362 30.4714 3.5286C30.3464 3.40357 30.1768 3.33333 30 3.33333H10C9.82319 3.33333 9.65362 3.40357 9.5286 3.5286C9.40357 3.65362 9.33333 3.82319 9.33333 4V8C9.33333 8.36819 9.03486 8.66667 8.66667 8.66667C8.29848 8.66667 8 8.36819 8 8V4C8 3.46957 8.21071 2.96086 8.58579 2.58579Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16C16 15.6319 16.2985 15.3334 16.6667 15.3334H31.3333C31.7015 15.3334 32 15.6319 32 16C32 16.3682 31.7015 16.6667 31.3333 16.6667H16.6667C16.2985 16.6667 16 16.3682 16 16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9.33329C16 8.9651 16.2985 8.66663 16.6667 8.66663H31.3333C31.7015 8.66663 32 8.9651 32 9.33329C32 9.70148 31.7015 9.99996 31.3333 9.99996H16.6667C16.2985 9.99996 16 9.70148 16 9.33329Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.66671C1.63181 8.66671 1.33333 8.96518 1.33333 9.33337V22.6667C1.33333 23.0349 1.63181 23.3334 2 23.3334H15.3333C15.7015 23.3334 16 23.0349 16 22.6667V9.33337C16 8.96518 15.7015 8.66671 15.3333 8.66671H2ZM0 9.33337C0 8.2288 0.895431 7.33337 2 7.33337H15.3333C16.4379 7.33337 17.3333 8.2288 17.3333 9.33337V22.6667C17.3333 23.7713 16.4379 24.6667 15.3333 24.6667H2C0.895431 24.6667 0 23.7713 0 22.6667V9.33337Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90689 11.4879C5.18974 11.2522 5.61011 11.2904 5.84582 11.5733L12.5125 19.5733C12.7482 19.8561 12.71 20.2765 12.4271 20.5122C12.1443 20.7479 11.7239 20.7097 11.4882 20.4268L4.82153 12.4268C4.58582 12.144 4.62403 11.7236 4.90689 11.4879Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4271 11.4879C12.71 11.7236 12.7482 12.144 12.5125 12.4268L5.84582 20.4268C5.61011 20.7097 5.18974 20.7479 4.90689 20.5122C4.62403 20.2765 4.58582 19.8561 4.82153 19.5733L11.4882 11.5733C11.7239 11.2904 12.1443 11.2522 12.4271 11.4879Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1735 2C20.5417 2 20.8402 2.29848 20.8402 2.66667V22H31.3335C31.7017 22 32.0002 22.2985 32.0002 22.6667C32.0002 23.0349 31.7017 23.3333 31.3335 23.3333H20.1735C19.8053 23.3333 19.5068 23.0349 19.5068 22.6667V2.66667C19.5068 2.29848 19.8053 2 20.1735 2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftExcel);
export default __webpack_public_path__ + "static/media/microsoft_excel.c872a68d86b138848210b8ea6f88e42f.svg";
export { ForwardRef as ReactComponent };